/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlane,
  faPlaneDeparture,
  faRoute,
  faHashtag,
  faUser,
  faThumbtack,
  faSun,
  faMoon,
  faAngleDown,
  faAngleUp,
  faPlayCircle,
  faExclamationTriangle,
  faMapMarkerAlt,
  faExclamationCircle,
  faWifi,
  faEllipsisH,
  faArrowRight,
  faCircleNotch,
  faExchangeAlt,
  faArrowsAlt,
  faChevronUp,
  faExpandArrowsAlt,
  faBinoculars,
} from '@fortawesome/free-solid-svg-icons';

/**
 * Register all fontawesome icons
 */
const registerFontAwesomeIcons = () => {
  library.add(
    faPlane,
    faPlaneDeparture,
    faRoute,
    faHashtag,
    faBinoculars,
    faUser,
    faThumbtack,
    faSun,
    faMoon,
    faAngleDown,
    faAngleUp,
    faPlayCircle,
    faExclamationTriangle,
    faMapMarkerAlt,
    faExclamationCircle,
    faWifi,
    faEllipsisH,
    faArrowRight,
    faCircleNotch,
    faExchangeAlt,
    faArrowsAlt,
    faChevronUp,
    faExpandArrowsAlt,
  );
};

export default registerFontAwesomeIcons;
